import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { HerracContext } from "../../App";
import './SubcategoriesForm.css';

function ConstructionEquipmentForm({ additionalAttributes, setAdditionalAttributes, subCategoryId }) {
  const [filteredBrands, setFilteredBrands] = useState([]);
  const [filteredModels, setFilteredModels] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState("");
  const { fuelTypeData } = useContext(HerracContext);

  // Debug logging
  useEffect(() => {
    console.log('🏗️ ConstructionEquipmentForm mounted with subCategoryId:', subCategoryId);
    console.log('📋 Current additionalAttributes:', additionalAttributes);
  }, [subCategoryId, additionalAttributes]);

  useEffect(() => {
    if (subCategoryId) {
      console.log('📦 Fetching brands for construction equipment...');
      axios.get(`https://api.herracim.az/api/Brand/BySubCategoryId?subCategoryId=${subCategoryId}`)
        .then(res => {
          console.log('✅ Brands loaded:', res.data.length, 'items');
          setFilteredBrands(res.data);
          setFilteredModels([]);
        })
        .catch(err => {
          console.error('❌ Error loading brands:', err);
          setFilteredBrands([]);
        });
    } else {
      setFilteredBrands([]);
      setFilteredModels([]);
    }
  }, [subCategoryId]);

  useEffect(() => {
    if (selectedBrand) {
      console.log('📦 Fetching models for brand:', selectedBrand);
      axios.get(`https://api.herracim.az/api/Model/ByBrandId?brandId=${selectedBrand}`)
        .then(res => {
          console.log('✅ Models loaded:', res.data.length, 'items');
          setFilteredModels(res.data);
        })
        .catch(err => {
          console.error('❌ Error loading models:', err);
          setFilteredModels([]);
        });
    } else {
      setFilteredModels([]);
    }
  }, [selectedBrand]);

  const handleBrandChange = (e) => {
    const brandId = e.target.value;
    console.log('🏷️ Brand selected:', brandId);
    
    setSelectedBrand(brandId);
    setAdditionalAttributes({
      ...additionalAttributes,
      brandId: brandId,
      modelId: ""
    });
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    console.log(`🔧 Field changed: ${name} = ${value}`);
    
    setAdditionalAttributes({
      ...additionalAttributes,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const years = Array.from({ length: new Date().getFullYear() - 1979 }, (_, i) => 1980 + i).reverse();

  return (
    <div className="constructionEquipmentForm">
      <div>
        <h3>
          Marka <span>*</span>
          <span className="tooltip-icon" title="Tikinti texnikası istehsalçısı">ℹ️</span>
        </h3>
        <select 
          name="brandId" 
          onChange={handleBrandChange} 
          disabled={!filteredBrands.length}
          defaultValue=""
        >
          <option value="" disabled>
            {filteredBrands.length === 0 ? 'Yüklənir...' : 'Seçin'}
          </option>
          {filteredBrands.map((b) => (
            <option key={b.id} value={b.id}>{b.name}</option>
          ))}
        </select>
      </div>

      <div>
        <h3>
          Model <span>*</span>
          <span className="tooltip-icon" title="Texnika modeli">ℹ️</span>
        </h3>
        <select 
          name="modelId" 
          onChange={handleChange} 
          disabled={!filteredModels.length}
          defaultValue=""
        >
          <option value="" disabled>
            {selectedBrand ? (filteredModels.length === 0 ? 'Yüklənir...' : 'Seçin') : 'Əvvəlcə marka seçin'}
          </option>
          {filteredModels.map((m) => (
            <option key={m.id} value={m.id}>{m.name}</option>
          ))}
        </select>
      </div>
          
      <div>
        <h3>
          İstehsal ili <span>*</span>
          <span className="tooltip-icon" title="Buraxılış ili">ℹ️</span>
        </h3>
        <select name="year" onChange={handleChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          {years.map(year => (
            <option key={year} value={year}>{year}</option>
          ))}
        </select>
      </div>

      <div>
        <h3>
          Yanacaq növü <span>*</span>
          <span className="tooltip-icon" title="Mühərrik yanacağı">ℹ️</span>
        </h3>
        <select name="fuelTypeId" onChange={handleChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          {fuelTypeData.map((fuelType) => (
            <option key={fuelType.id} value={fuelType.id}>{fuelType.name}</option>
          ))}
        </select>
      </div>

      <div>
        <h3>
          Motor gücü (HP) <span>*</span>
          <span className="tooltip-icon" title="Horsepower">ℹ️</span>
        </h3>
        <input 
          type="number" 
          name="horsePower" 
          min="1" 
          placeholder="200"
          onChange={handleChange} 
          required
        />
      </div>

      <div>
        <h3>
          Mühərrik gücü (a.g.) <span>*</span>
          <span className="tooltip-icon" title="At gücü">ℹ️</span>
        </h3>
        <input 
          type="number" 
          name="enginePower" 
          placeholder="200"
          min="50"
          max="1000"
          onChange={handleChange} 
          required
        />
      </div>

      <div>
        <h3>
          Mühərrik həcmi (L) <span>*</span>
          <span className="tooltip-icon" title="Engine displacement">ℹ️</span>
        </h3>
        <input 
          type="number" 
          step="0.1"
          name="engineVolume" 
          placeholder="6.0"
          min="2"
          max="20"
          onChange={handleChange} 
          required
        />
      </div>

      <div>
        <h3>
          İşləmə saatı (moto-saat) <span>*</span>
          <span className="tooltip-icon" title="Engine hours">ℹ️</span>
        </h3>
        <input 
          type="number" 
          name="workingHours" 
          min="0" 
          placeholder="5000"
          onChange={handleChange} 
          required
        />
      </div>

      <div>
        <h3>
          Yükqaldırma qabiliyyəti (ton) <span>*</span>
          <span className="tooltip-icon" title="Lifting capacity">ℹ️</span>
        </h3>
        <input 
          type="number" 
          step="0.1"
          name="liftingCapacity" 
          min="1" 
          placeholder="5.0"
          onChange={handleChange} 
          required
        />
      </div>

      <div>
        <h3>
          Ölçülər (UxExH) <span>*</span>
          <span className="tooltip-icon" title="Length x Width x Height (meters)">ℹ️</span>
        </h3>
        <input 
          type="text" 
          name="dimensions" 
          placeholder="8.5 x 2.5 x 3.2"
          onChange={handleChange} 
          required
        />
      </div>

      <div>
        <h3>
          Sürət qutusu <span>*</span>
          <span className="tooltip-icon" title="Transmissiya tipi">ℹ️</span>
        </h3>
        <select name="transmission" onChange={handleChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          <option value="Avtomat">Avtomat (Automatic)</option>
          <option value="Mexanik">Mexanik (Manual)</option>
          <option value="Hidrostatik">Hidrostatik</option>
          <option value="Powershift">Powershift</option>
        </select>
      </div>

      <div>
        <h3>
          Ötürücü tipi <span>*</span>
          <span className="tooltip-icon" title="Drive type">ℹ️</span>
        </h3>
        <select name="driveType" onChange={handleChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          <option value="Ön">Ön (Front)</option>
          <option value="Arxa">Arxa (Rear)</option>
          <option value="Tam">Tam (4WD / AWD)</option>
        </select>
      </div>

      <div>
        <h3>
          Rəng <span>*</span>
          <span className="tooltip-icon" title="Korpus rəngi">ℹ️</span>
        </h3>
        <input 
          type="text" 
          name="color" 
          placeholder="Sarı, Narıncı, Ağ..."
          onChange={handleChange} 
          required
        />
      </div>

      <div>
        <h3>
          Oturacaq sayı <span>*</span>
          <span className="tooltip-icon" title="Kabin oturacaqları">ℹ️</span>
        </h3>
        <select name="seatCount" onChange={handleChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          <option value="1">1 (Operator)</option>
          <option value="2">2</option>
          <option value="3">3+</option>
        </select>
      </div>

      <div>
        <h3>
          Qapı sayı <span>*</span>
          <span className="tooltip-icon" title="Kabin qapıları">ℹ️</span>
        </h3>
        <select name="doorCount" onChange={handleChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          <option value="1">1 qapı</option>
          <option value="2">2 qapı</option>
          <option value="3">3+ qapı</option>
        </select>
      </div>

      <div>
        <h3>
          Texnika yenidirmi? <span>*</span>
          <span className="tooltip-icon" title="0 saat yenidirmi?">ℹ️</span>
        </h3>
        <select name="isNew" onChange={handleChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          <option value="true">Bəli (0 saat)</option>
          <option value="false">Xeyr (İşlənmiş)</option>
        </select>
      </div>

      <div>
        <h3>
          Sahib sayı <span>*</span>
          <span className="tooltip-icon" title="Neçənci sahibdir?">ℹ️</span>
        </h3>
        <input 
          type="number" 
          name="ownerCount" 
          min="0" 
          max={10}
          placeholder="1"
          onChange={handleChange} 
          required
        />
      </div>

      <div>
        <h3>
          Texniki baxışdan keçib? <span>*</span>
          <span className="tooltip-icon" title="Technical inspection">ℹ️</span>
        </h3>
        <select name="hasTechnicalInspection" onChange={handleChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          <option value="true">Bəli ✅</option>
          <option value="false">Xeyr ❌</option>
        </select>
      </div>

      <div>
        <h3>
          Sığorta var? <span>*</span>
          <span className="tooltip-icon" title="Insurance">ℹ️</span>
        </h3>
        <select name="hasInsurance" onChange={handleChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          <option value="true">Bəli ✅</option>
          <option value="false">Xeyr ❌</option>
        </select>
      </div>

      <div>
        <h3>
          Qəzalı olub? <span>*</span>
          <span className="tooltip-icon" title="Qəza keçirib?">ℹ️</span>
        </h3>
        <select name="isAccidented" onChange={handleChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          <option value="true">Bəli ⚠️</option>
          <option value="false">Xeyr ✅</option>
        </select>
      </div>

      <div>
        <h3>
          VIN nömrəsi <span>*</span>
          <span className="tooltip-icon" title="Unikal identifikasiya nömrəsi">ℹ️</span>
        </h3>
        <input 
          type="text" 
          name="vin" 
          placeholder="1HGBH41JXMN109186"
          maxLength={17}
          onChange={handleChange} 
          required
        />
      </div>

      <div>
        <h3>
          Bazar ölkəsi <span>*</span>
          <span className="tooltip-icon" title="Hansı bazar üçün istehsal olunub">ℹ️</span>
        </h3>
        <select name="marketCountry" onChange={handleChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          <option value="Yaponiya">Yaponiya</option>
          <option value="Avropa">Avropa</option>
          <option value="Amerika">Amerika (ABŞ)</option>
          <option value="Çin">Çin</option>
          <option value="Koreya">Cənubi Koreya</option>
          <option value="Türkiyə">Türkiyə</option>
          <option value="Digər">Digər</option>
        </select>
      </div>

      <div>
        <h3>
          İstifadə bölgəsi <span>*</span>
          <span className="tooltip-icon" title="Texnikanın istifadə sahəsi">ℹ️</span>
        </h3>
        <select name="usageRegion" onChange={handleChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          <option value="Tikinti sahəsi">Tikinti sahəsi</option>
          <option value="Yol təmiri / salınması">Yol təmiri / salınması</option>
          <option value="Daş karxanası">Daş karxanası</option>
          <option value="Quyu qazma və qazma işləri">Quyu qazma və qazma işləri</option>
          <option value="Material daşıma">Material daşıma</option>
          <option value="Kənd təsərrüfatı işləri">Kənd təsərrüfatı işləri</option>
          <option value="Hündürlükdə işlər (qaldırıcı texnika)">Hündürlükdə işlər</option>
          <option value="Digər">Digər</option>
        </select>
      </div>
    </div>
  );
}

export default ConstructionEquipmentForm;